/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ReportMetadataPage} from '../models/ReportMetadataPage';
import type {ReportMetadataRequest} from '../models/ReportMetadataRequest';

export interface GetAccountUsageReports$Request {
    accountId: number;
    reportMetadataRequest?: ReportMetadataRequest;
}

export interface GetAccountUsageReports$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountUsageReportsRequest = createAction<PayloadData<void, GetAccountUsageReports$Request>>('USAGE_REPORTS_METADATA__GET_ACCOUNT_USAGE_REPORTS__REQUEST');
export const getAccountUsageReportsSuccess = createAction<PayloadData<ReportMetadataPage, GetAccountUsageReports$Request>>('USAGE_REPORTS_METADATA__GET_ACCOUNT_USAGE_REPORTS__SUCCESS');
export const getAccountUsageReportsFailure = createAction<PayloadData<Error, GetAccountUsageReports$Request, true>>('USAGE_REPORTS_METADATA__GET_ACCOUNT_USAGE_REPORTS__FAILURE');

export const getAccountUsageReportsActions = [
    getAccountUsageReportsRequest,
    getAccountUsageReportsSuccess,
    getAccountUsageReportsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {ReportMetadataRequest} [meta.reportMetadataRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountUsageReports = (meta: GetAccountUsageReports$Request, config?: GetAccountUsageReports$Config) => {
    return {
        CALL_API: {
            types: getAccountUsageReportsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/reports/usage/accounts/${meta.accountId}`,
            TRANSPORT_REQUEST_BODY: meta.reportMetadataRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

